import PropTypes from 'prop-types'
import { propTypesUser } from '../modules/currentUser/types'

export const commentsShape = {
  id: PropTypes.number.isRequired,
  comment: PropTypes.string.isRequired,
  user: PropTypes.shape(propTypesUser).isRequired,
}
